/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useParams } from 'react-router';
import { PARAMS } from '../definitions/RouterStates';
import { useLocation } from './useLocation';

export function useRoom(): { roomId: string } {
  const { roomId } = useParams<{ [PARAMS.ROOM_ID]: string }>();
  const { pathname } = useLocation();
  if (!roomId) {
    throw new Error(`Cannot call get room id for url ${pathname}`);
  }
  return { roomId };
}
